// import * as sha1 from 'js-sha1'
import constants from '@/constants'
import _ from 'lodash'
// const aux = {
//   // translation: function (value, locale, language) {
//   //   let aux = value
//   //   try {
//   //     aux = JSON.parse(value)
//   //   } catch (e) {}
//   //   if (aux[locale]) {
//   //     return aux[locale]
//   //   } else if (aux['en']) {
//   //     return aux['en']
//   //   } else {
//   //     const firstKey = Object.keys(aux)[0]
//   //     return aux[firstKey]
//   //   }
//   // },
//   verifyURL: function (url) {
//     if (url.indexOf('www') >= 0 || url.indexOf('http') >= 0) return url
//     return `${window.location.protocol}//www.${url}`
//   }
// }

const utils = {
  formatNumber(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  getColor (value) {
    if (value === 'DESCUBREGROUP') return '#FFA726'
    else if (value === 'BPESTACIONES') return '#557755'
    else if (value === 'RUYBESA') return '#E53935'
    else if (value === 'CAJASIETE') return '#375652'
    else if (value === 'MHI') return '#8E8783'
    else if (value === 'PARQUE') return '#044C74'
  },
  getStatus (value) {
    const aux = new Date() - new Date(value)
      var cd = 24 * 60 * 60 * 1000,
          ch = 60 * 60 * 1000,
          d = Math.floor(aux / cd),
          h = Math.floor( (aux - d * cd) / ch),
          m = Math.round( (aux - d * cd - h * ch) / 60000),
          pad = function(n){ return n < 10 ? '0' + n : n; };
    if( m === 60 ){
      h++
      m = 0
    }
    if( h === 24 ){
      d++
      h = 0
    }

    if (d >= 1) {
      return { //error
        error: true,
        icon: 'mdi-close-network',
        color: '#D32F2F'
      }
    } else if (h >= 1) {
      return { //naranja
        icon: 'mdi-network-off',
        color: '#FFA726'
      }
    } else if ((h * 60 + m) >= 16) {
      return { //naranja
        icon: 'mdi-network-off',
        color: '#FFD180'
      }
    }  else {
      return { //correcto
        icon: 'mdi-check-network',
        color: '#7CB240'
      }
    }
    return { //error
      icon: 'mdi-close-network',
      color: '#D32F2F'
    }
  },
  getDownloadStatus (value) {
    const aux = new Date() - new Date(value)
      var cd = 24 * 60 * 60 * 1000,
          ch = 60 * 60 * 1000,
          d = Math.floor(aux / cd),
          h = Math.floor( (aux - d * cd) / ch),
          m = Math.round( (aux - d * cd - h * ch) / 60000),
          pad = function(n){ return n < 10 ? '0' + n : n; };
    if( m === 60 ){
      h++;
      m = 0;
    }
    if( h === 24 ){
      d++;
      h = 0;
    }

    if (d >= 15) {
      return true
    } else {
      return false
    }
  },
  transfMenu (oldValue, newValue) {
    if (!oldValue.noRestore) { // se utilizar para cuando se guarda la edición del menú [formMenu/index]
      oldValue.Name = newValue.Name
      oldValue.Menus = newValue.Menus
      oldValue.Type = newValue.Type
      // oldValue.IsMenuWithSubmenu = newValue.IsMenuWithSubmenu
    }
  },
  isMobile () {
    if (navigator.userAgent.match(/iPad/i) != null) return false
    if (navigator.userAgent.match(/Mobi/)) return true
    if ('screen' in window && window.screen.width <= 800 && window.screen.height <= 600) return true

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    if (connection && connection.type === 'cellular') return true

    return false
  },
  isIpad () {
    return navigator.userAgent.match(/iPad/i) != null
  },
  getDefaultContentByType (menuType, ord, BGColor) {
    let result = {}
    if (menuType === 2) { // TITLE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Title: { es: ''},
        Style: {
          SizeMult: 0,
          ToUpperCase: false,
          TextAlign: 'left'
        }
      }
    } else if (menuType === 3) { // SPACE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Size: 10
      }
    } else if (menuType === 4) { // IMAGE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Image: null
      }
    } else if (menuType === 5) { // IFRAME
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        URL: null,
        Height: 600
      }
    } else if (menuType === 6) { // ALERT
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        AlertText: { es: ''},
        Icon: 'mdi-information',
        BGColor: BGColor,
        Color: BGColor
      }
    } else if (menuType === 7) { // GALLERY
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Images: [],
      }
    } else if (menuType === 8) { // VIDEO
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        VideoURL: null,
        TypeVideo: 'youtube'
      }
    } else if (menuType === 9) { // METEO
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType
      }
    } else if (menuType === 10) { // Map
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Height: 600,
        Lat: 40.419008,
        Lon: -3.703927
      }
    } else if (menuType === 11) { // TWITTER
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Account: 'descubretv'
      }
    } else if (menuType === 12) { // FACEBOOK
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Account: 'descubregroup'
      }
    } else if (menuType === 13) { // ACTIVITY
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        TypeActivity: 0
      }
    } else if (menuType === 14) { // PDF
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        URL: null
      }
    } else if (menuType === 15) { // TIMELINE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        TimelineDate: new Date().toISOString().slice(0, 10),
        TimelineImage: 'https://cdn.vuetifyjs.com/images/cards/forest.jpg',
        Times: [],
        TimeLineTextHeader: { es: ''},
        TimeLineSubTextHeader: { es: ''},
      }
    } else if (menuType === 16) { // TEXT
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Text: { es: ''},
      }
    } else if (menuType === 17) { // CONTACT
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        HideDivider: false,
        ContactItems: []
      }
    } else if (menuType === 18) { // DIVIDER
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        DividerUp: 0,
        DividerDown: 0,
        DividerLeft: 15,
        DividerRight: 15
      }
    } else if (menuType === 19) { // SHOW
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        TypeShow: 0
      }
    } else if (menuType === 20) { // SITE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        SiteImage: null,
        SiteTitle: { es: ''},
        SiteSubtitle: { es: ''},
        SiteMoreInfo: { es: ''},
        SiteAdress: '',
        SiteLat: '',
        SiteLon: '',
        SitePhone: '',
        SiteWeb: '',
        SiteEmail: ''
      }
    } else if (menuType === 21 || menuType === 22 || menuType === 24 || menuType === 25 || menuType === 26) { // AGENDA, PARRILLA, PROPERTY, COMMERCIAL, QUEUE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType
      }
    } else if (menuType === 23) { // WIFI
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        WifiName: { es: ''},
        WifiIsWep: false,
        WifiSSID: '',
        WifiPassword: ''
      }
    }
    result.ORD = ord
    return result
  },
  removeNewNew (menus) {
    return menus.filter(x => !x.isNew)
  },
  getUserID () {
    return localStorage.getItem('user') 
  },
  getEnterpiseID () {
    return localStorage.getItem('enterprise') 
  },
  isPrivate: function () {
    const host = window.location.host
    const parts = host.split('.')
    const domainLength = 3 // route1.example.com => domain length = 3
    if (parts.length === (domainLength - 1)) {
      return true
    } else if (parts[0] === 'www') {
      if (parts[0] === 'www' && (parts[1] === 'admin' || parts[1] === process.env.VUE_APP_URL)) {
        return true
      }
    } else if (parts[0] === 'admin') {
      return true
    }
    return false
  },
  getDomain: function () {
    const getHostname = window.location.hostname
    return getHostname.split('.')[0] === 'www' ? getHostname.split('.')[1] : getHostname.split('.')[0]
  },
  getAPIURL: function (path, isPrivate, id) {
    const hostname = window.location.hostname
    const pathSplit = hostname.split('.')
    let domain = ''
    if (pathSplit.length > 2) {
      domain = pathSplit[0] === 'www' ? pathSplit[1] : pathSplit[0]
    }
    if (domain === process.env.VUE_APP_API_URL.split('.')[0] || domain === 'admin') domain = ''
    domain = !isPrivate && domain.length === 0 ? id : domain
    const area = isPrivate ? 'private' : 'public'
    let www = process.env.VUE_APP_ENV === 'development' ? '' : 'www.'
    let result = `${window.location.protocol}//${www}${process.env.VUE_APP_API_URL}/${area}/${path}`
    // old 2090806
    // if (id && isPrivate) result = `${result}/${id}`
    // // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`?domain=${domain}`)
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`/${domain}`)
    // old 2090806
    // new 2090806
    if (id && isPrivate) result = `${result}/${id}`
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`?domain=${domain}`)
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : id ? result.concat(`/${id}`) : result.concat(`/${domain}`)
    return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : id ? result.concat(`/${id}`) : result
    // new 2090806
  
  },
  getAllLanguages (selectedLanguages) {
    const languages = []
    for (var key in constants.isoLangs) {
      languages.push({
        ID: key,
        Name: constants.isoLangs[key].nativeName.split(', ').join('-')
      })
    }
    if (selectedLanguages) {
      return languages.filter(x => selectedLanguages.indexOf(x.ID) >= 0)
    }
    return languages
  },
  setActiveEnterprise: function (v_, enterprise, redirect) {
    if (enterprise) {
      localStorage.setItem('enterprise', enterprise.ID)
      v_.$store.state.app.enterpriseID = enterprise ? enterprise.ID : null
      v_.$store.state.app.enterpriseName = enterprise ? enterprise.Name : ''
    }
    if (redirect) v_.$router.push('/dashboard')
  },
  getActiveEnterpriseID: function (v_) {
    return (v_.$store.state.app.enterpriseID)
  },
  getActiveEnterpriseColor: function (v_) {
    return (v_.$store.state.app.enterpriseColor)
  },
  checkIsActive(menu) {
    if (!menu.IsTemp) {
      return true
    } else {
      if (menu.StartDate <= new Date() && (menu.EndDate >= new Date() || menu.NoEndDate)) {
        return true
      } else {
        return false
      }
    }
  },
  getTranslation: function (value, locale) {
    let aux = value
    // try {
    //   aux = JSON.parse(value)
    // } catch (e) {
    //   console.log(e)
    // }
    if (aux[locale]) {
      return aux[locale]
    } else if (aux['en']) {
      return aux['en']
    } else {
      const firstKey = Object.keys(aux)[0]
      return aux[firstKey]
    }
  },
  pad: function (value, nItem = 2) {
    let aux = ''
    for (let i = 0; i < nItem; i++) aux = aux.concat('0')
    let result = aux.concat(value)
    result = result.substring(result.length - nItem, result.length)
    return result
  },
  // setActiveEnterprise: function (v_, enterprises, noRedirect) {
  //   const selectEnterprise = enterprises.length > 0 ? enterprises[0] : enterprises
  //   //localStorage.setItem('enterprise', JSON.stringify(selectEnterprise))
  //   v_.$store.state.app.image = selectEnterprise.Banner && selectEnterprise.Banner.length > 0 ? aux.verifyURL(selectEnterprise.Banner) : ''
  //   v_.$store.state.app.enterpriseName = selectEnterprise.Name && selectEnterprise.Name.length > 0 ? selectEnterprise.Name : ''
  //   v_.$store.state.app.enterpriseID = selectEnterprise.ID && selectEnterprise.ID.length > 0 ? selectEnterprise.ID : ''
  //   if (!noRedirect) v_.$router.push('/dashboard')
  // },
  // getAllLanguages (selectedLanguages) {
  //   const languages = []
  //   for (var key in constants.isoLangs) {
  //     languages.push({
  //       ID: key,
  //       Name: constants.isoLangs[key].nativeName.split(', ').join('-')
  //     })
  //   }
  //   if (selectedLanguages) {
  //     return languages.filter(x => selectedLanguages.indexOf(x.ID) >= 0)
  //   }
  //   return languages
  // },
  // getAllMenuType () {
  //   const menuType = []
  //   for (var key in constants.menuType) {
  //     menuType.push({
  //       ID: constants.menuType[key],
  //       Name: key
  //     })
  //   }
  //   return menuType
  // },
  // isAdmin: function () {
  //   return localStorage.getItem('role') === sha1('1')
  // },
  // isSuperuser: function () {
  //   return localStorage.getItem('role') === sha1('-1')
  // },
  // setActiveEnterprise: function (v_, enterprise, noRedirect) {
  //   const selectEnterprise = enterprise.length > 0 ? enterprise[0] : enterprise

  //   localStorage.setItem('enterprise', JSON.stringify(selectEnterprise))
  //   v_.$store.state.app.image = selectEnterprise.Banner && selectEnterprise.Banner.length > 0 ? aux.verifyURL(selectEnterprise.Banner) : ''
  //   v_.$store.state.app.enterpriseName = selectEnterprise.Name && selectEnterprise.Name.length > 0 ? selectEnterprise.Name : ''
  //   v_.$store.state.app.enterpriseID = selectEnterprise.ID && selectEnterprise.ID.length > 0 ? selectEnterprise.ID : ''
  //   if (!noRedirect) v_.$router.push('/dashboard')
  // },
  // getActiveEnterprise: function () {
  //   const enterprise = JSON.parse(localStorage.getItem('enterprise'))
  //   // console.log(enterprise.Languages)
  //   try {
  //     enterprise.Languages = enterprise.Languages.toString().split(',')
  //   } catch (error) {
  //     console.error(error)
  //   }
  //   // console.log(enterprise.Languages)
  //   try {
  //     enterprise.Carousel = enterprise.Carousel ? enterprise.Carousel.toString().split(',') : []
  //   } catch (error) {
  //     console.error(error)
  //   }
  //   return enterprise
  // },
  // getActiveUser: function () {
  //   return JSON.parse(localStorage.getItem('user'))
  // },
  // getDomain: function () {
  //   const getHostname = window.location.hostname
  //   return getHostname.split('.')[0] === 'www' ? getHostname.split('.')[1] : getHostname.split('.')[0]
  // },
  // verifyURL: function (url) {
  //   return aux.verifyURL(url)
  // },
  // getPublicURL: function (domain) {
  //   return `${window.location.protocol}//www.${domain}.${process.env.VUE_APP_API_URL}`
  // },
  // getTranslation: function (value, locale, language) {
  //   return aux.translation(value, locale, language)
  // },
  // prepareMenu: function (menus, locale, language, expandPref) {
  //   const result = []
  //   menus.forEach(function (element) {
  //     // if (element.Content) {
  //     //   element.Content = element.Content
  //     //   try {
  //     //     element.Content = JSON.parse(element.Content)
  //     //   } catch (error) {}
  //     // }
  //     element.T_Name = aux.translation(element.Name, locale, language)
  //     element.submenus = menus.filter(x => x.ParentID === element.ID)
  //     if (expandPref) {
  //       if (expandPref.content) {
  //         element.isExpand = true
  //       } else if (element.submenus.length > 0 && expandPref.submenu) {
  //         element.isExpand = true
  //       } else {
  //         element.isExpand = false
  //       }
  //     }
  //     result.push(element)
  //   })
  //   return result.filter(x => !x.ParentID)
  // },
  // checkAvailability: function (availability) {
  //   if (!availability.IsTemp) return true
  //   if (availability.IsTemp && (new Date() >= new Date(availability.StartDate) && (new Date() <= new Date(availability.EndDate) || availability.NoEndDate))) {
  //     return true
  //   }
  //   return false
  // }
}

export default utils
